import { availabilityCheckPoints } from '../availabilityCheckPoint'
import { describeTable } from './describeTable'

describeTable(availabilityCheckPoints, {
  description:
    'Test addresses the office uses on the ERP availability map to probe what the public booking widget would offer at a given location (which technicians, which days). Configuration data maintained by hand; joins addresses via address_id. Not customer data and not part of any metric.',
  columns: {
    addressId: 'The probe address.',
    description: 'Why this point exists (e.g. "Espoo reuna-alue").',
  },
})
